export default "__VITE_ASSET__Cv_yZL8u__"